import { render, staticRenderFns } from "./viewDialog.vue?vue&type=template&id=a526c4f0&scoped=true"
import script from "./viewDialog.vue?vue&type=script&lang=js"
export * from "./viewDialog.vue?vue&type=script&lang=js"
import style0 from "./viewDialog.vue?vue&type=style&index=0&id=a526c4f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a526c4f0",
  null
  
)

export default component.exports